import './calendar-checkbox.style.sass';
import template from './calendar-checkbox.tpl.pug';

export default {
    selector: 'dbACalendarCheckbox',
    template: template(),
    bindings: {
        name: '<',
        selected: '<'
    }
};



// WEBPACK FOOTER //
// ./src/application/component/calendar-checkbox/calendar-checkbox.cmpt.js